import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {ConfService} from "../conf.service";
import {AuthedApiService} from "../authed-api.service";

@Injectable({
  providedIn: 'root'
})
export class DevexTesterDataService {

  private _rawDataKeyTypes: any;
  constructor(private confPost: ConfService,
              private apiService: AuthedApiService) { }
  setRawDataKeyTypes(forceDataFetch = false) {
    return new Promise((resolve, reject) => {
      if (this._rawDataKeyTypes !== null && this._rawDataKeyTypes !== undefined && !forceDataFetch) {
        resolve('success');
      } else {
        this.apiService.getRawDataKeyTypes().subscribe(authTypes => {
          let res: any;
          res = authTypes;
          this._rawDataKeyTypes = res['dataTypes'];
          resolve('success');
        }, error => {
          resolve('failed');
        });
      }
    });
  }

  get rawDataKeyTypes() {
    return this._rawDataKeyTypes;
  }

}
